import { GeneralFieldController } from "./general-field-controller";

export class RelatedCasesTableController extends GeneralFieldController {
	override mapInitialValue(value: unknown): unknown {
		if (value || !this.parent.context.cases.length) {
			return super.mapInitialValue(value);
		}
		return super.mapInitialValue("");
	}
}
